import React from 'react';
import { classNameBuilder } from '../../utils/className';
import Select from 'react-select';
import './SelectField.scss';

interface IProps {
    name?: string;
    options: any[];
    onChange: (selectOption: any) => void;
    value: any;
    className?: string;
    label?: string;
    [x: string]: any;
    placeholder?: string;
}

const SelectField: React.FC<IProps> = ({
    name,
    options = [],
    onChange,
    value,
    className,
    color,
    label,
    placeholder,
    ...rest
}) => {
    const cn = classNameBuilder('select-field');

    return (
        <div className={cn()}>
            <Select
                // hideSelectedOptions
                name={name}
                options={options}
                className={className}
                classNames={{
                    placeholder: () => cn('placeholder'),
                }}
                classNamePrefix={className}
                onChange={onChange}
                placeholder={placeholder}
                value={
                    value
                        ? {
                              value: value,
                              label: value?.name || value?.label,
                          }
                        : null
                }
                {...rest}
            />
        </div>
    );
};

export default SelectField;
